<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><em class="fas fa-file-alt"></em></span
    >{{ "PurchaseOrder.SearchForm.Header" | translate }}
  </h1>

  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="p-fluid grid">
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2">
                {{ "PurchaseOrder.SearchForm.Plant" | translate }}
              </p>
              <laas-plant-dropdown
                [isSingle]="true"
                formControlName="warehouse">
              </laas-plant-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2">
                {{ "PurchaseOrder.SearchForm.PoNo" | translate }}
              </p>
              <p-chips separator="," formControlName="poNos"></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2">
                {{ "PurchaseOrder.SearchForm.AsnNo" | translate }}
              </p>
              <p-chips separator="," formControlName="asnNos"></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2">
                {{ "PurchaseOrder.SearchForm.DnNo" | translate }}
              </p>
              <p-chips separator="," formControlName="dnNos"></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-3 laas-calendar">
              <laas-calendar
                #createDt
                [title]="'PurchaseOrder.SearchForm.CreateDt'"
                [enableMaxDateIsToday]="false"
                [showRangeMode]="true"
                [showStartMode]="true"
                (onDateChange)="dateOnChange($event, 'createDt')"
              >
              </laas-calendar>
            </div>
          </div>
          <div class="block">
            <div class="inline-block mb-1">
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Search' | translate }}"
                (click)="searchBtnClick()"
              ></button>
            </div>
            <div class="inline-block mb-1">
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Reset' | translate }}"
                class="p-button-secondary ml-4"
                (click)="resetBtnClick()"
              ></button>
            </div>
          </div>
        </form>
      </p-accordionTab>

      <ng-content *ngTemplateOutlet="PoHeaderTemplate"></ng-content>
      <ng-content *ngTemplateOutlet="PoDetailTemplate"></ng-content>
    </p-accordion>
  </p-card>
</div>

<!--PO Header-->
<ng-template #PoHeaderTemplate>
  <div class="mt-2">
    <laas-data-table
      #PoHeader
      [value]="headerResults"
      [loading]="isHeaderLoading"
      [defaultColumns]="poHeaderColumns"
      (onRowSelect)="searchDetail($event)"
      dataKey="poNo"
    >
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'poNo'">
              <div class="overflow-text">
                <a
                  href="javascript: void(0);"
                  (click)="editPo($event, rowData)"
                  >{{ rowData[col.field] }}</a
                >
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'warehouse'">
              {{ rowData[col.field] }}
            </ng-container>
            <ng-container *ngSwitchCase="'createDt'">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | date : "yyyy-MM-dd" : this.laasSetting.facilityTimeZone
                    | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith : "-" }}
              </div>
            </ng-container>
          </ng-container>
        </td>
      </ng-template>
    </laas-data-table>
  </div>
</ng-template>

<!--PO Detail-->
<ng-template #PoDetailTemplate>
  <div class="mt-2">
    <laas-data-table
      #PoDetail
      [value]="detailResults"
      [loading]="isDetailLoading"
      [defaultColumns]="poDetailColumns"
    >
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'createDt'">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | date : "yyyy-MM-dd" : this.laasSetting.facilityTimeZone
                    | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith : "-" }}
              </div>
            </ng-container>
          </ng-container>
        </td>
      </ng-template>
    </laas-data-table>
  </div>
</ng-template>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
